import { styles } from "~/components/stablecoins/tab";

export enum Page {
  STABLECOINS,
  CHAINS,
}

type Props = Readonly<{
  page: Page;
}>;

export function AnalyticsNav({ page }: Props): JSX.Element {
  return (
    <ul>
      <li>
        <a
          className={styles({ selected: page == Page.STABLECOINS })}
          href="/stablecoins"
        >
          Stablecoins
        </a>
        <a className={styles({ selected: page == Page.CHAINS })} href="/chains">
          Chains
        </a>
      </li>
    </ul>
  );
}
